export const EXPERIMENT_BEHAVIOR_DISCLOSED_ASSIGNED_DIFFICULTY =
  "disclosed_assigned_difficulty";
export const EXPERIMENT_BEHAVIOR_LEGACY_UNDISCLOSED = "legacy_undisclosed";

export const PERFORMANCE_FEEDBACK_SHOWN = "shown";
export const PERFORMANCE_FEEDBACK_HIDDEN = "hidden";

export function normalizeExperimentBehavior(value) {
  return value === EXPERIMENT_BEHAVIOR_LEGACY_UNDISCLOSED
    ? EXPERIMENT_BEHAVIOR_LEGACY_UNDISCLOSED
    : EXPERIMENT_BEHAVIOR_DISCLOSED_ASSIGNED_DIFFICULTY;
}

export function normalizePerformanceFeedback(value) {
  return value === PERFORMANCE_FEEDBACK_HIDDEN
    ? PERFORMANCE_FEEDBACK_HIDDEN
    : PERFORMANCE_FEEDBACK_SHOWN;
}

export function usesDisclosedAssignedDifficulty(design) {
  // Games started before behavior versioning have no field and must stay legacy.
  if (!Object.prototype.hasOwnProperty.call(design || {}, "experimentBehavior")) {
    return false;
  }

  return (
    normalizeExperimentBehavior(design?.experimentBehavior) ===
    EXPERIMENT_BEHAVIOR_DISCLOSED_ASSIGNED_DIFFICULTY
  );
}

export function showsPerformanceFeedback(design) {
  if (
    normalizeExperimentBehavior(design?.experimentBehavior) ===
    EXPERIMENT_BEHAVIOR_LEGACY_UNDISCLOSED
  ) {
    return true;
  }

  return (
    normalizePerformanceFeedback(design?.performanceFeedback) ===
    PERFORMANCE_FEEDBACK_SHOWN
  );
}
